<template>
  <v-container class="lastArticlesWrapper"
               ref="articlesWrapper"
               v-bind:class="{checkoutBorderRad: isCheckout}"
  >
    <v-row
        class="articleCardRow"
        ref="articles"
        v-bind:class="{reverseArticles: !renderData.category && !renderData.cart}"
    >
      <div v-if="!enableReorder" style="width: 100%;">
        <v-col cols="12"
               v-for="(article, index) in renderData.products.flat()"
               :key="article.itemNo"
               :value="article.id"
               class="articleCardCol"
               style="padding-left: 0px; padding-right: 0px;"
        >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line @click="goToArticle(article.itemNo)">
                    <v-list-item-avatar tile>
                    <!--
                    <v-img :src="loadProductImage(article.itemNo)"
                           lazy-src=""
                           contain
                    >
                    -->
                    <v-img :src="baseUrl + 'storage/webps/'+ (article.itemNo.indexOf('-') > -1 ? article.itemNo.substr(0, article.itemNo.indexOf('-')) : article.itemNo)+'.webp'"
                           lazy-src=""
                           contain
                    >
                      <template v-slot:placeholder>
                        <v-skeleton-loader type="avatar" tile>

                        </v-skeleton-loader>
                      </template>
                    </v-img>
                    </v-list-item-avatar>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                             v-bind:class="{textEllipsis : !renderData.category && !renderData.cart}"
                      >
                        {{ article.description }}
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" v-if="renderData.cart || renderData.category || renderData.deposit" class="textSize__14 text--black pb-0 pt-2">
                          <span class="articleAdditionalInfo">Artikelnummer: {{ article.itemNo}}</span>
                        </v-col>
                      </div>
                      <v-col cols="12" v-if="article.availability === 'G' && !renderData.deposit" class="articleStatusCol">
                        <div class="articleAvailable"></div>
                        <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                      </v-col>
                      <v-col cols="12" v-if="article.availability ==='R' && !renderData.deposit" class="articleStatusCol">
                        <div class="articleNotAvailable"></div>
                        <span class="articleStatusNotAvailable"
                              v-if="!article.delisted"
                        >
                          Artikel ist derzeit nicht lieferbar
                        </span>
                        <span class="articleStatusNotAvailable"
                              v-if="article.delisted"
                        >
                          Artikel ist ausgelistet
                        </span>
                      </v-col>
                      <v-col cols="12" v-if="article.availability==='Y'" class="articleStatusCol">
                        <div class="articlePending"></div>
                        <span class="articleStatusPending">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                      </v-col>

                      <v-col cols="9" v-if="!renderData.cart && !renderData.deposit && (getPermissions && getPermissions.indexOf('PRODSTANDARD') > -1)">
                        <div class="discountRibbonWrap"
                             v-if="article.price.length > 0 && article.price[0].action === 1"
                        >
                          <div class="discountRibbon">
                          </div>
                          <div class="discountRibbonContent">
                              <span class="ribbonText">Aktion</span>
                          </div>
                        </div>


                        <span class="articlePriceMain" v-if="article.price.length > 0 && article.price[0].price > 0">{{ article.price[0].price | parsePrice }} € </span>
                        <span class="articlePriceMain" v-if="getPriceAvailability(article)">{{ article.default_price.uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length > 0 && article.price[0].uvp !== null"> UVP: {{ article.price[0].uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length > 0 && (article.price[0].uvp === null && article.default_price.uvp >0)"> UVP: {{ article.default_price.uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length === 0 && (article.default_price !== null && article.default_price.uvp > 0)"> UVP: {{ article.default_price.uvp | parsePrice }} € </span>
                      </v-col>
                      <v-col cols="9" v-if="!renderData.cart && !renderData.deposit && (getPermissions && getPermissions.indexOf('LAGER') > -1)">
                        <span><strong>Lagerplatz:</strong> {{article.shelfNo ? article.shelfNo : 'keine Daten vorhanden.'}}</span>
                      </v-col>

                      <v-col cols="3">
                        <addToCart :article="article" v-if="!getInventoryMode && renderData.watchlist && (article.availability === 'G' || article.availability === 'Y')"/>
                        <addToInventory :article="article" class="listAddToCartFormButton" v-if="getInventoryMode && renderData.watchlist"/>
                      </v-col>

                      <v-col v-if="renderData.cart" cols="12" class="articleAmountCart">
                        <span v-if="article.itemNo.indexOf('-') !== -1" @click.stop="editAmount(article.orderedAmount)">
                          {{ article.itemNo.substr(article.itemNo.indexOf('-')+1) * article.orderedAmount }}
                        </span>
                        <span v-else @click.stop="editAmount(article.orderedAmount)">
                          {{ article.orderedAmount }}
                        </span>
                        <span v-if="article.itemNo.indexOf('-') !== -1">
                          {{ article.orderedType | capitalize }}
                        </span>
                        <span v-else>
                          {{ article.orderedType | capitalize }}
                        </span>
                      </v-col>
                      <v-col v-if="renderData.cart" cols="12" class="pa-0">
                        <span class="articlePriceMain">{{ article.totalPriceArticle | parsePrice }} €</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
              <v-btn v-if="renderData.cart && !renderData.order" class="removeItem" @click="removeFromMyCart(index)">
                <TrashCan/>
              </v-btn>
            </v-card>
        </v-col>
        <div style="height: 75px;"/>
      </div>

      <div v-if="enableReorder" style="height: 100%;">
        <slick-list lockAxis="y" :useDragHandle="false"
                    v-model="flatArticles" infinite="true"
                    style="height: 100%; width:100%;overflow-y: scroll;"
                    :pressDelay="200"
                    helperClass="body-helper-config-fields-field-set"
        >
          <slick-item v-for="(article, index) in flatArticles"
                      :index="index"
                      :key="index"
                      class="articleCardCol mb-6"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line @click="goToArticle(article.itemNo)">
                <v-list-item-avatar tile>
                  <!--
                  <v-img :src="loadProductImage(article.itemNo)"
                         lazy-src=""
                         contain
                  >
                  -->
                  <v-img :src="baseUrl + 'storage/webps/'+ (article.itemNo.indexOf('-') > -1 ? article.itemNo.substr(0, article.itemNo.indexOf('-')) : article.itemNo)+'.webp'"
                         lazy-src=""
                         contain
                  >
                    <template v-slot:placeholder>
                      <v-skeleton-loader type="avatar" tile>

                      </v-skeleton-loader>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                             v-bind:class="{textEllipsis : !renderData.category && !renderData.cart}"
                      >
                        {{ article.description }}
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" v-if="renderData.cart || renderData.category || renderData.deposit" class="textSize__14 text--black pb-0 pt-2">
                          <span class="articleAdditionalInfo">Artikelnummer: {{ article.itemNo}}</span>
                        </v-col>
                      </div>
                      <v-col cols="12" v-if="article.availability === 'G' && !renderData.deposit" class="articleStatusCol">
                        <div class="articleAvailable"></div>
                        <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                      </v-col>
                      <v-col cols="12" v-if="article.availability ==='R' && !renderData.deposit" class="articleStatusCol">
                        <div class="articleNotAvailable"></div>
                        <span class="articleStatusNotAvailable"
                              v-if="!article.delisted"
                        >
                          Artikel ist derzeit nicht lieferbar
                        </span>
                        <span class="articleStatusNotAvailable"
                              v-if="article.delisted"
                        >
                          Artikel ist ausgelistet
                        </span>
                      </v-col>
                      <v-col cols="12" v-if="article.availability==='Y'" class="articleStatusCol">
                        <div class="articlePending"></div>
                        <span class="articleStatusPending">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                      </v-col>

                      <v-col cols="9" v-if="!renderData.cart && !renderData.deposit && (getPermissions && getPermissions.indexOf('PRODSTANDARD') > -1)">
                        <div class="discountRibbonWrap"
                             v-if="article.price.length > 0 && article.price[0].action === 1"
                        >
                          <div class="discountRibbon">
                          </div>
                          <div class="discountRibbonContent">
                            <span class="ribbonText">Aktion</span>
                          </div>
                        </div>


                        <span class="articlePriceMain" v-if="article.price.length > 0 && article.price[0].price > 0">{{ article.price[0].price | parsePrice }} € </span>
                        <span class="articlePriceMain" v-if="getPriceAvailability(article)">{{ article.default_price.uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length > 0 && article.price[0].uvp !== null"> UVP: {{ article.price[0].uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length > 0 && (article.price[0].uvp === null && article.default_price.uvp >0)"> UVP: {{ article.default_price.uvp | parsePrice }} € </span>
                        <span class="articlePriceUVP" v-if="article.price.length === 0 && (article.default_price !== null && article.default_price.uvp > 0)"> UVP: {{ article.default_price.uvp | parsePrice }} € </span>
                      </v-col>
                      <v-col cols="9" v-if="!renderData.cart && !renderData.deposit && (getPermissions && getPermissions.indexOf('LAGER') > -1)">
                        <span>Lagerplatz: {{article.shelfNo ? article.shelfNo : 'keine Daten vorhanden.'}}</span>
                      </v-col>

                      <v-col cols="3">
                        <addToCart :article="article" v-if="!getInventoryMode && renderData.watchlist && (article.availability === 'G' || article.availability === 'Y')"/>
                        <addToInventory :article="article" class="listAddToCartFormButton" v-if="getInventoryMode && renderData.watchlist"/>
                      </v-col>

                      <v-col v-if="renderData.cart" cols="12" class="articleAmountCart">
                        <span v-if="article.itemNo.indexOf('-') !== -1" @click.stop="editAmount(article.orderedAmount)">
                          {{ article.itemNo.substr(article.itemNo.indexOf('-')+1) * article.orderedAmount }}
                        </span>
                        <span v-else @click.stop="editAmount(article.orderedAmount)">
                          {{ article.orderedAmount }}
                        </span>
                        <span v-if="article.itemNo.indexOf('-') !== -1">
                          {{ article.orderedType | capitalize }}
                        </span>
                        <span v-else>
                          {{ article.orderedType | capitalize }}
                        </span>
                      </v-col>
                      <v-col v-if="renderData.cart" cols="12" class="pa-0">
                        <span class="articlePriceMain">{{ article.totalPriceArticle | parsePrice }} €</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
              <v-btn v-if="renderData.cart && !renderData.order" class="removeItem" @click="removeFromMyCart(index)">
                <TrashCan/>
              </v-btn>
            </v-card>
          </slick-item>
        </slick-list>
        <div style="height: 30px;"/>
      </div>
    </v-row>
  </v-container>


</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex"
import router from '@/router'
import TrashCan from "@/assets/cart/trashCan";
import AddToCart from "@/app/cart/addToCart";
import AddToInventory from '@/app/inventory/addToInventory'
import {api} from "@/config/api";

import {SlickList, SlickItem, HandleDirective} from 'vue-slicksort';


export default {
  name: "productList",
  components: {TrashCan, AddToCart, AddToInventory, SlickList, SlickItem},
  directives: { handle: HandleDirective },
  props: ['renderData', 'reorder'],

  data:() => {
    return {
      items: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6', 'Item 7', 'Item 8'],
      baseUrl: api.url
    }
  },

  methods: {

    ...mapActions({
      removeFromCart: 'removeFromCart',
      updateTotalCartPrice: 'updateTotalCartPrice',
      setCartDrawerState: 'setCartDrawerState'
    }),

    ...mapMutations({
      setIssueMore: 'setIssueMore',
      setCurrentPosition: 'setCurrentPosition',
      setTopScroll: 'setTopScroll'
    }),

    ...mapGetters({
      getCartDrawerState: 'getCartDrawerState',
    }),

    ...mapState({
      issueMore: 'issueMore',
      currentPosition: 'currentPosition'
    }),

    getPriceAvailability(article) {
      if(article.price.length === 0 && article.default_price !== null) {
        if(article.default_price.uvp !== null) {
          return true
        }
        else {return false}
      }
    },

    goToArticle(artNr) {
      this.setTopScroll(false)
      if(artNr.indexOf('-') === -1) {
        this.$router.push({path: `/shop/article/${artNr}`})
        if(this.getCartDrawerState()) {
          this.setCartDrawerState()
        }
      }
      else if(artNr.indexOf('-') !== -1) {
        let parsedArtNr = artNr.substring(0, artNr.indexOf('-'))
        this.$router.push({path: `/shop/article/${parsedArtNr}`})
        if(this.getCartDrawerState()) {
          this.setCartDrawerState()
        }
      }
    },

    goBack() {
      router.go(-1)
    },

    removeFromMyCart(data) {
      const artNr = this.getCartContents[data].itemNo
      const price = this.getCartContents[data].totalPriceArticle
      var articleDetails = {artNr: artNr}
      const snackTxt = {name: this.getCartContents[data].description, type:this.getCartContents[data].orderedType,  amount: this.getCartContents[data].orderedAmount}
      var removeData = [articleDetails, snackTxt]
      this.removeFromCart(removeData)
      this.updateTotalCartPrice(price)
      this.getCartContents.splice(data, 1)
    },

    loadProductImage(artNr) {
      let adjustedArtNr = null
      if (artNr.indexOf('-') === -1) {
          adjustedArtNr = artNr
      }
      else {
        adjustedArtNr = artNr.substr(0,artNr.indexOf('-'))
      }
      return 'api/pic/'+adjustedArtNr
    },

    editAmount(amount) {
      console.log(amount)
    }

  },

  computed: {
    ...mapGetters({
      getLoadingState: 'getLoadingState',
      getCartContents: 'getCartContents',
      getCategoryBreadcrumbs: 'getCategoryBreadcrumbs',
      getPermissions: 'getPermissions'
    }),

    ...mapGetters('inventory', {
      getInventoryMode: 'getInventoryMode'
    }),

    enableReorder () {
      let state = false
      if(this.reorder === 'undefined') {
        state = false
      } else {
        if(this.reorder) {
          state = true
        } else {
          state = false
        }
      }
      return state
    },
    flatArticles: {
      get: function () {
        if(this.reorder) {
          return this.renderData.products.flat()
        }
        return []
      },
      set: function (newVal) {
        // send update
        if(this.reorder) {
          this.$emit('valueChanged', newVal)
          this.renderData.products = newVal
        }
      }
    },

    isCheckout() {
      if(router.currentRoute.name === 'Checkout' && !this.getCartDrawerState()) {
        return true
      }
      else {
        return false
      }
    },

  },
}
</script>

<style>
  .checkoutBorderRad {
    border-radius: 30px!important;
  }
  .body-helper-config-fields-field-set.articleCardCol {
    font-family: "Mark OT", sans-serif;
  }
  .body-helper-config-fields-field-set.articleCardCol .v-list-item {
    background-color: lightgrey;
  }
  .body-helper-config-fields-field-set.articleCardCol .articleCard .v-avatar {
    border-radius: 0px;
    margin-right: 16px;
  }
  .body-helper-config-fields-field-set.articleCardCol .articleCard .v-list-item__content {
    padding: 0px;
  }

  .body-helper-config-fields-field-set.articleCardCol .articleCard .v-list-item__content .articleAdditionalInfoWrapper .textSize__14 {
    padding-top: 8px!important;
  }
</style>
